import React, { useState } from "react";
import { Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLang } from "@/i18n";
import { PRINT_LANGS } from "@/lib/printI18n";
import { langName } from "@/lib/constants";

const today = () => new Date().toISOString().slice(0, 10);

export default function PrintDialog({ withLabel = false }) {
  const { t, lang: uiLang } = useLang();
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(uiLang);
  const [from, setFrom] = useState(today());
  const [to, setTo] = useState("");

  const go = () => {
    if (!to || to < from) return;
    const url = `/print?from=${from}&to=${to}&lang=${lang}`;
    setOpen(false);
    // Eerst het venster netjes sluiten, daarna het nieuwe tabblad openen.
    setTimeout(() => window.open(url, "_blank"), 150);
  };

  return (
    <>
      <Button variant="outline" size={withLabel ? "sm" : "icon"} className={withLabel ? "h-8" : "h-8 w-8"}
        onClick={() => setOpen(true)} data-testid="print-button" title={t("print_map")}>
        <Printer className="h-4 w-4" />
        {withLabel && <span className="ml-1">{t("print_map")}</span>}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="print-dialog">
          <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Printer className="h-4 w-4" />{t("print_map")}</DialogTitle></DialogHeader>
          <p className="text-sm text-muted-foreground">{t("print_period_desc")}</p>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="pfrom" className="mb-1.5 block">{t("from")}</Label>
              <Input id="pfrom" type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="print-from" />
            </div>
            <div>
              <Label htmlFor="pto" className="mb-1.5 block">{t("to")}</Label>
              <Input id="pto" type="date" min={from} value={to} onChange={(e) => setTo(e.target.value)} data-testid="print-to" />
            </div>
          </div>
          <div>
            <Label className="mb-1.5 block">{t("language")}</Label>
            <Select value={lang} onValueChange={setLang}>
              <SelectTrigger data-testid="print-lang"><SelectValue /></SelectTrigger>
              <SelectContent>{PRINT_LANGS.map((l) => <SelectItem key={l.code} value={l.code}>{langName(l.code, uiLang)}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>{t("cancel")}</Button>
            <Button onClick={go} disabled={!to || to < from} data-testid="print-confirm"><Printer className="h-4 w-4 mr-1" />{t("print")}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
